import Image from 'next/image'
import cx from 'classnames'
import { ArtistProps } from '../types'
import { NEXT_IMAGE_QUALITY } from '~constants'
import styles from '../Calendar.module.scss'
import { FormattedEvent } from '../types/Event'

export const EventInfo = ({
  handleDateSelection,
  artist,
  event,
  eventsTime
}: {
  handleDateSelection: (event: FormattedEvent[], artist: Artist) => void
  artist: ArtistProps
  event: FormattedEvent[]
  eventsTime: string[]
}) => {
  const getEventTimes = (eventTimes: string[]) => {
    if (eventTimes?.length == 1) {
      return <span>{eventTimes[0]}</span>
    } else {
      return eventTimes
        .slice(0, 2)
        .map((time: string, index: number) =>
          index < 1 ? <span key={index}>{time},&nbsp;&nbsp;</span> : <span key={index}>{time}&nbsp;&nbsp;</span>
        )
    }
  }

  const artistImage = artist?.calendarMonthViewImage

  return (
    <div
      key={artist?.artistId}
      onClick={() => handleDateSelection(event, artist)}
      className={styles['event-container']}
    >
      <div className={styles['event-copy-container']}>
        <span className={styles['event-title']}>{artist?.artistName}</span>
        <div className={styles['calendar__events']}>
          {getEventTimes(eventsTime ?? [])}
          {eventsTime?.length > 2 && (
            <span className={cx(styles['more-events'])}>&nbsp; + {eventsTime?.length - 2} more</span>
          )}
        </div>
      </div>
      {artistImage?.url && (
        <Image
          alt={artistImage?.altText || ''}
          src={artistImage?.url}
          fill
          style={{ objectFit: 'cover' }}
          className={styles['edp-image']}
          quality={NEXT_IMAGE_QUALITY}
        />
      )}
    </div>
  )
}
